var map = {
	"./cov_bedrijf.jpg": 1560,
	"./cov_default.jpg": 5501,
	"./cov_folkyr.jpg": 1353,
	"./cov_hypotheek_vitaal.jpg": 7257,
	"./cov_kfhein.jpg": 6287,
	"./cov_madras.jpg": 6837,
	"./cov_panjab.jpg": 5779,
	"./cov_sunderban.jpg": 2516,
	"./cov_swiftrinity.jpg": 1327,
	"./cov_yuhi.jpg": 9191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7556;